module.exports = __webpack_public_path__ + "media/vuesrc/apps/public/images/investments/hero-mobile-f007d4901686074b6e10d49916dffa2e.png";